import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articleContent } from "@/mocks/article-content";
import { articles } from "@/mocks/articles";

const articleImages: Record<string, string> = {
  "best-superbuy-spreadsheet-guide": "https://readdy.ai/api/search-image?query=Person%20sitting%20at%20a%20minimalist%20Scandinavian%20desk%20pointing%20at%20a%20large%20monitor%20showing%20colorful%20data%20charts%20and%20spreadsheets%2C%20bright%20daylight%20from%20floor%20to%20ceiling%20windows%2C%20modern%20office%20with%20indoor%20plants%2C%20editorial%20documentary%20style&width=600&height=400&seq=ap-v2-01&orientation=landscape",
  "how-to-use-superbuy-spreadsheet": "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20wooden%20desk%20with%20an%20open%20laptop%20displaying%20step%20by%20step%20instructions%2C%20surrounded%20by%20a%20notepad%20pen%20and%20a%20steaming%20coffee%20mug%2C%20morning%20sunlight%20casting%20long%20shadows%2C%20cozy%20productive%20home%20office&width=600&height=400&seq=ap-v2-02&orientation=landscape",
  "is-superbuy-spreadsheet-safe": "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20stainless%20steel%20padlock%20resting%20on%20a%20keyboard%20with%20a%20shield%20icon%20glowing%20on%20the%20laptop%20screen%20behind%20it%2C%20low%20key%20dramatic%20lighting%2C%20cybersecurity%20concept%2C%20dark%20moody%20atmosphere&width=600&height=400&seq=ap-v2-03&orientation=landscape",
  "superbuy-spreadsheet-vs-manual": "https://readdy.ai/api/search-image?query=Two%20contrasting%20workspace%20setups%20side%20by%20side%2C%20one%20messy%20with%20scattered%20papers%20and%20one%20organized%20with%20a%20clean%20laptop%20setup%2C%20bright%20studio%20lighting%2C%20comparison%20concept%20photography%2C%20editorial%20style&width=600&height=400&seq=ap-v2-04&orientation=landscape",
  "best-superbuy-spreadsheet-categories": "https://readdy.ai/api/search-image?query=Color%20coded%20file%20folders%20and%20product%20catalog%20magazines%20neatly%20arranged%20in%20rows%20on%20a%20white%20shelf%2C%20organized%20retail%20display%20concept%2C%20bright%20gallery%20lighting%2C%20clean%20minimalist%20aesthetic&width=600&height=400&seq=ap-v2-05&orientation=landscape",
  "best-shipping-lines-superbuy": "https://readdy.ai/api/search-image?query=Stack%20of%20cardboard%20shipping%20boxes%20of%20various%20sizes%20with%20international%20shipping%20labels%20visible%2C%20warehouse%20setting%20with%20warm%20industrial%20lighting%2C%20logistics%20and%20fulfillment%20photography&width=600&height=400&seq=ap-v2-06&orientation=landscape",
  "how-qc-photos-work-superbuy": "https://readdy.ai/api/search-image?query=Professional%20photographer%20hands%20holding%20a%20DSLR%20camera%20shooting%20a%20product%20on%20a%20white%20photo%20table%2C%20studio%20lighting%20setup%20visible%2C%20product%20inspection%20scene%2C%20commercial%20photography%20workshop&width=600&height=400&seq=ap-v2-07&orientation=landscape",
  "save-money-superbuy-shipping": "https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20coins%20and%20folded%20dollar%20bills%20next%20to%20a%20laptop%20showing%20a%20shipping%20cost%20calculator%2C%20warm%20desk%20lamp%20lighting%2C%20savings%20and%20budget%20concept%2C%20cozy%20evening%20atmosphere&width=600&height=400&seq=ap-v2-08&orientation=landscape",
  "top-seller-guide-superbuy": "https://readdy.ai/api/search-image?query=Row%20of%20five%20golden%20stars%20rating%20displayed%20on%20a%20tablet%20screen%20with%20seller%20profile%20information%20visible%2C%20resting%20on%20a%20marble%20countertop%2C%20soft%20boutique%20lighting%2C%20trust%20and%20review%20concept&width=600&height=400&seq=ap-v2-09&orientation=landscape",
  "beginner-buying-checklist-superbuy": "https://readdy.ai/api/search-image?query=Handwritten%20checklist%20on%20a%20clipboard%20with%20checkmarks%20next%20to%20an%20open%20laptop%20and%20a%20credit%20card%2C%20bright%20clean%20desk%20setup%2C%20first%20time%20buyer%20concept%2C%20fresh%20morning%20light&width=600&height=400&seq=ap-v2-10&orientation=landscape",
  "common-shopping-mistakes-superbuy": "https://readdy.ai/api/search-image?query=Red%20warning%20sign%20icon%20on%20a%20laptop%20screen%20surrounded%20by%20shopping%20bags%20and%20receipts%2C%20cautionary%20shopping%20concept%2C%20dramatic%20contrast%20lighting%2C%20alert%20and%20awareness%20theme&width=600&height=400&seq=ap-v2-11&orientation=landscape",
  "how-to-read-product-links-superbuy": "https://readdy.ai/api/search-image?query=Magnifying%20glass%20placed%20over%20a%20laptop%20screen%20showing%20URL%20links%20and%20product%20codes%2C%20close%20up%20macro%20photography%2C%20investigation%20and%20research%20concept%2C%20soft%20blue%20screen%20glow&width=600&height=400&seq=ap-v2-12&orientation=landscape",
  "superbuy-shipping-time-guide": "https://readdy.ai/api/search-image?query=World%20map%20with%20colorful%20pins%20marking%20different%20countries%20on%20a%20cork%20board%2C%20with%20a%20digital%20tablet%20showing%20delivery%20tracking%20information%20beside%20it%2C%20global%20shipping%20concept%2C%20warm%20office%20lighting&width=600&height=400&seq=ap-v2-13&orientation=landscape",
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  const siteUrl = import.meta.env.VITE_SITE_URL;
  const articleMeta = articles.find((a) => a.slug === slug);
  const displayTitle = articleMeta?.title || articleContent.title;
  const displayDate = articleMeta?.date || articleContent.datePublished;
  const displayReadTime = articleMeta?.readTime || "8 min read";
  const { sections, conclusion, author } = articleContent;

  useEffect(() => {
    document.title = `${displayTitle} | Superbuy Spreadsheet Forum`;
    window.scrollTo(0, 0);
  }, [displayTitle]);

  const pageUrl = `${siteUrl}/article/${slug}`;

  const relatedArticles = articles
    .filter((a) => a.slug !== slug)
    .slice(0, 4);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-16">
        <section className="bg-background-50 py-10 md:py-16">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6 flex-wrap">
              <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
                Home
              </Link>
              <span className="text-foreground-300">/</span>
              <span className="text-accent-600 font-medium whitespace-nowrap">Shopping Guide</span>
              <span className="text-foreground-300">/</span>
              <span className="text-foreground-500 truncate">{displayTitle}</span>
            </nav>

            <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-700 bg-accent-100/70 rounded-full mb-4">
              Buying Guide
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              {displayTitle}
            </h1>

            <div className="flex items-center gap-4 text-sm text-foreground-400 mt-4">
              <span className="flex items-center gap-1.5">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-calendar-line text-xs"></i>
                </span>
                Published: {displayDate}
              </span>
              <span className="text-foreground-300">·</span>
              <span className="flex items-center gap-1.5">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-time-line text-xs"></i>
                </span>
                {displayReadTime}
              </span>
              <span className="text-foreground-300">·</span>
              <span className="flex items-center gap-1.5">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-user-line text-xs"></i>
                </span>
                {author}
              </span>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-50">
          <article className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="prose-custom">
              {sections.map((section, idx) => {
                if (section.type === "faq") {
                  return (
                    <div key={idx} className="mb-10">
                      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
                        {section.heading}
                      </h2>
                      <div className="space-y-4">
                        {section.questions?.map((q, qi) => (
                          <div key={qi} className="border border-background-200/70 rounded-xl p-5 bg-white">
                            <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                              {q.question}
                            </h3>
                            <p className="text-sm text-foreground-600 leading-relaxed">
                              {q.answer}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }

                if (section.type === "introduction") {
                  return (
                    <div key={idx} className="mb-10">
                      <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                        {section.content}
                      </p>
                    </div>
                  );
                }

                return (
                  <div key={idx} className="mb-10">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                      {section.heading}
                    </h2>
                    <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
                      {section.content.split("\n\n").map((para, pi) => (
                        <p key={pi}>{para}</p>
                      ))}
                    </div>
                  </div>
                );
              })}

              <div className="mb-10 bg-accent-100/50 rounded-xl p-6 md:p-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  Conclusion
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                  {conclusion}
                </p>
                <div className="flex flex-wrap gap-3">
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-white text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-home-4-line text-xs"></i>
                    </span>
                    Back to Home
                  </Link>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    superbuy spreadsheet
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-up-line text-xs"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </article>
        </section>

        {/* Related Guides */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
              Related <span className="text-accent-600">Guides</span>
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              Continue reading more superbuy spreadsheet resources
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {relatedArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-white rounded-xl overflow-hidden hover:shadow-md transition-all cursor-pointer"
                >
                  <div className="w-full h-[180px] md:h-[200px] overflow-hidden">
                    <img
                      src={articleImages[article.slug]}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-400 mb-3 line-clamp-2">{article.excerpt}</p>
                    <div className="flex items-center gap-2 text-xs text-foreground-400">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-calendar-line"></i>
                      </span>
                      <span>{article.date}</span>
                      <span className="text-foreground-300">·</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="relative w-full h-[350px] md:h-[420px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20shopping%20lifestyle%20scene%20with%20fashion%20items%20casually%20arranged%20on%20a%20light%20wooden%20surface%2C%20golden%20hour%20sunlight%20streaming%20in%2C%20neutral%20cream%20and%20beige%20tones%2C%20editorial%20product%20photography%2C%20soft%20atmosphere%2C%20aspirational%20lifestyle%20aesthetic&width=1600&height=600&seq=cta-article-v2&orientation=landscape"
              alt="Continue shopping with Superbuy Spreadsheet"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/25 to-black/15"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
                Ready to Start Shopping?
              </h2>
              <p className="text-sm md:text-base text-white/70 mb-6 max-w-lg mx-auto">
                Visit our main website for the latest product categories and spreadsheet updates.
              </p>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
              >
                buy it now
                <span className="w-5 h-5 rounded-full bg-foreground-950 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white text-xs"></i>
                </span>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": displayTitle,
            "author": { "@type": "Organization", "name": author },
            "publisher": { "@type": "Organization", "name": author },
            "datePublished": displayDate,
            "dateModified": "2026-06-21",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": pageUrl,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": siteUrl },
              { "@type": "ListItem", "position": 2, "name": "Shopping Guide", "item": siteUrl },
              { "@type": "ListItem", "position": 3, "name": displayTitle },
            ],
          }),
        }}
      />
    </div>
  );
}